import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { fetchExperienceById } from 'actions/ExperienceActions'
import { fetchUserReviewsByOrder } from 'actions/ReviewActions'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'
import { isOrderReviewed, isOrderReviewsLoaded } from 'selectors/reviewSelectors'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import moment from 'moment'

export default function useExperiencePurchaseDetails(order: App.Order, isPastOrder: boolean) {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  // Multi Cart Experiences - TODO: We need to update My Escapes/ ExperiencePurchaseSummary UI to support multiple experience items
  // Images, status, locations, dates, etc
  const experienceItem = order.experienceItems[0]

  const { experience, isMarkingAsRedeemed, isReviewed, isReviewLoaded } = useAppSelector((state) => ({
    experience: state.experience.experiences[experienceItem.experienceId],
    isMarkingAsRedeemed: !!state.experience.markingBookingDetailsAsRedeemed?.[experienceItem.id],
    isReviewed: isOrderReviewed(state, order.id),
    isReviewLoaded: isOrderReviewsLoaded(state, order.id),
  }), shallowEqual)

  let locationName = experienceItem.redemptionLocation?.name
  // for unredeemed gifts with multiple locations
  if (!locationName && experience?.redemptionLocations?.length > 1) {
    locationName = intl.formatMessage({
      id: 'lDGvS_1SF_snVx38zi93',
      defaultMessage: 'Multiple Locations',
      description: 'Fallback location label for experiences with multiple redemption locations',
    })
  }

  useEffect(() => {
    dispatch(fetchExperienceById(experienceItem.experienceId))

    if (isPastOrder && !isReviewLoaded) {
      dispatch(fetchUserReviewsByOrder(order.id))
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, experienceItem.experienceId])

  const firstImage = experience?.images[0]

  const experienceDate = experience?.hasCalendar && experienceItem.date && moment(experienceItem.date).format(SHORT_DAY_NAME_DAY_MONTH_YEAR)
  const experienceTime = experience?.hasTimeslots && experienceItem.time ? experienceItem.time : undefined

  return {
    image: firstImage,
    location: locationName,
    name: experience?.name,
    bookingNumber: experienceItem.bookingNumber,
    experienceDate,
    experienceTime,
    experienceItem,
    experience,
    isMarkingAsRedeemed,
    isReviewed,
    isReviewLoaded,
  }
}
